<h2 mat-dialog-title class="text-lg font-bold mb-1">Conf. Usuario</h2>
<mat-dialog-content class="modal-content">
    <form [formGroup]="form">
        <div class="mt-2 grid grid-cols-2 gap-x-4">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Nombre(s) y Apellidos(s)</mat-label>
                <input matInput [formControl]="first_name" name="first_name" disabled required>
            </mat-form-field>
           <mat-form-field appearance="fill" class="w-full">
                <mat-label>Correo Electrónico</mat-label>
                <input matInput [formControl]="email" name="email" required>
            </mat-form-field>
        </div>
        <div class="mt-2 grid gap-x-4 items-center" [ngClass]="!isExist ? 'grid-cols-3' : 'grid-cols-2'">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Usuario</mat-label>
                <input matInput [formControl]="username" name="usernameSetting" required>
            </mat-form-field>
            <div *ngIf="isExist && !editPassword" class="col-span-1 flex">
                <mat-slide-toggle color="primary" [(ngModel)]="editPassword" [ngModelOptions]="{standalone: true}">
                  Editar Contraseña
                </mat-slide-toggle>
            </div>
            @if(editPassword){
                @if(isExist){
                <!-- <mat-form-field appearance="fill" class="w-full">
                    <mat-label>
                        Contraseña Actual*
                        <mat-slide-toggle [(ngModel)]="editPassword" (change)="onPasswordChange()" [ngModelOptions]="{standalone: true}" color="primary">
                            Editar Contraseña
                        </mat-slide-toggle>
                    </mat-label>
                    <input matInput [(ngModel)]="old_password" [ngModelOptions]="{standalone: true}" aria-label="Contraseña Actual"
                        [type]="!hideold ? 'password' : 'text'" minlength="3" maxlength="100">
                    <mat-icon style="cursor: pointer;" class="text-muted" matSuffix (click)="hideold = !hideold">
                    {{!hideold ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                </mat-form-field> -->
                <mat-slide-toggle [(ngModel)]="editPassword" (change)="onPasswordChange()" [ngModelOptions]="{standalone: true}" color="primary">
                    Editar Contraseña
                </mat-slide-toggle>
                }
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>{{!isExist ? 'Contraseña' : 'Nueva Contraseña*'}}</mat-label>
                    <input matInput [formControl]="password" aria-label="Contraseña"
                        [type]="!hide ? 'password' : 'text'" minlength="3" maxlength="100">
                    <mat-icon style="cursor: pointer;" class="text-muted" matSuffix (click)="hide = !hide">
                    {{!hide ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                    <mat-error *ngIf="password.hasError('minlength')">
                    La contraseña debe tener al menos 3 caracteres
                    </mat-error>
                    <mat-error *ngIf="password.hasError('hasNumber') || password.hasError('hasCapitalCase')">
                    Debe incluir al menos un número y una letra mayúscula
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Repetir Contraseña</mat-label>
                    <input matInput [formControl]="password_confirmation" name="password_confirmation" 
                    [type]="!hidenew ? 'password' : 'text'">
                    <mat-icon style="cursor: pointer;" class="text-muted" matSuffix (click)="hidenew = !hidenew">
                        {{!hidenew ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error *ngIf="password_confirmation.hasError('mismatchedPasswords')">
                    La contraseña no coincide
                    </mat-error>
                </mat-form-field>
            }
        </div>
        <div class="mt-2 grid grid-cols-2 gap-x-4">
            <!--Req: no show allow_shared_user-->
            @if(false){
            <p class="mt-6">
                <mat-slide-toggle labelPosition="before" color="primary"
                [checked]="allow_shared_user.value === true" (change)="$event.checked ? allow_shared_user.setValue(true): allow_shared_user.setValue(false) ">
                ¿Permite Múltiples Cuentas?</mat-slide-toggle>
            </p>
            }
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Aplicaciones</mat-label>
                <mat-select [formControl]="type" [compareWith]="compareFn" multiple>
                    @for (aplication of applicationList; track aplication) {
                        <mat-optgroup [label]="aplication.name">
                          @for (subaplication of aplication.subApplications; track subaplication) {
                            <mat-option [value]="{ parentId: aplication._id, subId: subaplication._id }">
                                {{ subaplication.name }}
                            </mat-option>
                          }
                        </mat-optgroup>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onSubmit()"
      >Guardar</button>
</mat-dialog-actions>